import { createSelector } from "reselect";
import getDomain from "../base_getters/get_domain";

const getProjectsByFirebaseId = createSelector([
  getDomain
], (domain) => domain.projects.byFirebaseId);

export default getProjectsByFirebaseId;
